import { SupplierTypeEnum } from "./supplier-type-enum";

export const supplierTypeLabels = {
  [SupplierTypeEnum.INDIVIDUAL]: "Perorangan",
  [SupplierTypeEnum.COMPANY]: "Perusahaan",
  [SupplierTypeEnum.GOVERNMENT]: "Pemerintah",
};
